import helper from '@/shared/helper';

export function httpRequestInterceptor(config) {
	const token = helper.getLocalToken();
	const headers = config.headers;
	if (token) {
		headers.common.Authorization = `Bearer ${token}`;
		this.$bus.$emit('is-loading', true);
	} else {
		this.$bus.$emit('is-loading', true);
	}
	return config;
}

export function httpResponseSuccessInterceptor(response) {
	this.$bus.$emit('is-loading', false);
	return response;
}

export function httpResponseInterceptor(error) {
	this.$bus.$emit('is-loading', false);
	const status = error.response.status;
	const loginRoute = { name: 'page-admin' };
	if (status === 401) {
		this.showError('Su sesión expiró.');
		this.$router.push(loginRoute);
	} else if (status === 403) {
		this.showError('No tiene suficientes permisos para realizar ésta acción');
	} else if (status === 500) {
		this.showError();
	}
	return Promise.reject(error.response);
}



// WEBPACK FOOTER //
// ./src/http.js